import { GET_LANG_TIME_ZONE, GET_LANG_TIME_ZONE_SUCCESS, GET_LANG_TIME_ZONE_FAIL } from "./actionTypes";

export const getLangTime = () => ({
  type: GET_LANG_TIME_ZONE,
});

export const getLangTimeSuccess = data => ({
  type: GET_LANG_TIME_ZONE_SUCCESS,
  payload: data,
});

export const getLangTimeFail = error => ({
  type: GET_LANG_TIME_ZONE_FAIL,
  payload: error,
});
